import React from 'react';
import { MenuSection as AriaMenuSection } from 'react-aria-components';

type Props = {
  children: React.ReactNode;
};
export const MenuSection = ({ children }: Props) => {
  return <AriaMenuSection>{children}</AriaMenuSection>;
};
